import { render, staticRenderFns } from "./DocumentCodeSelection.vue?vue&type=template&id=6e1c3baf&scoped=true"
import script from "./DocumentCodeSelection.vue?vue&type=script&lang=js"
export * from "./DocumentCodeSelection.vue?vue&type=script&lang=js"
import style0 from "./DocumentCodeSelection.vue?vue&type=style&index=0&id=6e1c3baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c3baf",
  null
  
)

export default component.exports